import { FILE_EXPORT_FORMAT_CATALOG } from "@/object-actions/fileRecordExportCatalog";
import type {
  ObjectActionVariant,
  ResolvedObjectAction,
} from "@/object-actions/types";

export interface TextNoteDownloadParams {
  exportMarkdown: () => void;
  exportWord: () => void;
}

/**
 * Expands the registry `download` action on a text note into its format
 * variants (Markdown / Word), rendered as the same nested format submenu
 * file records get (see {@link attachFileRecordDownloadVariants}).
 */
export function attachTextNoteDownloadVariants(
  actions: ResolvedObjectAction[],
  params: TextNoteDownloadParams,
): ResolvedObjectAction[] {
  return actions.map((action) => {
    if (action.id !== "download") {
      return action;
    }

    const variants: ObjectActionVariant[] = [
      {
        id: "download:markdown",
        label: FILE_EXPORT_FORMAT_CATALOG.markdown.label,
        handler: params.exportMarkdown,
      },
      {
        id: "download:docx",
        label: FILE_EXPORT_FORMAT_CATALOG.docx.label,
        handler: params.exportWord,
      },
    ];

    return { ...action, variants, handler: () => {} };
  });
}
